import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'components/common/Elements/Elements';

import { protocolsColor } from 'utils/common';
import { links } from 'data/constants';

import classes from './AppIcon.module.scss';

const { innerIcons } = links;

const AppIcon = ({ icon }) => {
  const svg = icon.includes('.svg');

  const urlImg = icon.split('/')[icon.split('/').length - 1].slice(0, -4);

  return (
    <div className={classes.icon}>
      {svg ? (
        <Icon size="14px" icon={urlImg} color={protocolsColor[urlImg]} />
      ) : (
        <img src={`${innerIcons}${icon}`} width="20" height="20" alt="" />
      )}
    </div>
  );
};

AppIcon.propTypes = {
  icon: PropTypes.string
};

export default AppIcon;
